module.exports = __webpack_public_path__ + "statics/img/google.76e44b50.svg";